// Toggle a .is-scrolled class on <body> so CSS can collapse the utility-bar
// (and apply other "scrolled" tweaks) when the page is scrolled.
(() => {
  const threshold = 8;
  const update = () => {
    document.body.classList.toggle('is-scrolled', window.scrollY > threshold);
  };
  window.addEventListener('scroll', update, { passive: true });
  update();
})();
